/* eslint-disable */
import { useState, useMemo, useEffect } from "react";
import { saveToStorage, loadFromStorage } from "./Auth";
import { exportMatchPrepPDF, exportPreMatchPack, ExportButton } from "./ExportPDF";
import { useToast } from "./Auth";
import { COMPETITIONS, CLUBS, fetchLeagueTable, fetchOpenFootballFixtures } from "./FootballData";

/* ═══════════════════════════════════════════════════════════
   FOOTY ANALYST — FIXTURES & MATCH PREP
   Season schedule · Match prep hub · Team selection
   Results tracker · League table · AI match brief
═══════════════════════════════════════════════════════════ */

const FX_CSS = `
.fx-wrap { font-family:'DM Sans',sans-serif; background:var(--cream); min-height:100%; }

/* ── HEADER ── */
.fx-header { background:var(--ink); border-bottom:3px solid var(--mustard); padding:0; }
.fx-header-top { padding:1.2rem 1.5rem; display:flex; align-items:center; justify-content:space-between; flex-wrap:wrap; gap:0.75rem; }
.fx-header-title { font-family:'Bebas Neue',sans-serif; font-size:1.8rem; letter-spacing:3px; color:var(--white); line-height:1; }
.fx-header-sub { font-size:0.68rem; color:rgba(255,255,255,0.45); font-weight:300; margin-top:0.2rem; }
.fx-season-select { background:rgba(255,255,255,0.08); border:1px solid rgba(255,255,255,0.2); color:var(--white); padding:0.4rem 0.75rem; font-family:'DM Sans',sans-serif; font-size:0.72rem; font-weight:700; outline:none; cursor:pointer; }
.fx-season-select option { background:var(--ink); }

/* Stat strip */
.fx-stat-strip { display:flex; background:rgba(255,255,255,0.04); border-top:1px solid rgba(255,255,255,0.06); }
.fx-stat { flex:1; padding:0.65rem 1rem; text-align:center; border-right:1px solid rgba(255,255,255,0.06); }
.fx-stat:last-child { border-right:none; }
.fx-stat-val { font-family:'Bebas Neue',sans-serif; font-size:1.4rem; letter-spacing:2px; color:var(--mustard); line-height:1; }
.fx-stat-lbl { font-size:0.52rem; font-weight:700; letter-spacing:2px; text-transform:uppercase; color:rgba(255,255,255,0.35); margin-top:0.1rem; }
.fx-stat-val.green { color:#4ade80; }
.fx-stat-val.red { color:#f87171; }

/* ── TABS ── */
.fx-tabs { display:flex; background:var(--white); border-bottom:2px solid var(--rule); }
.fx-tab { padding:0.85rem 1.3rem; font-family:'DM Sans',sans-serif; font-size:0.72rem; font-weight:800; letter-spacing:1.5px; text-transform:uppercase; cursor:pointer; color:var(--muted); border-bottom:3px solid transparent; margin-bottom:-2px; white-space:nowrap; transition:all 0.2s; }
.fx-tab:hover { color:var(--teal); }
.fx-tab.on { color:var(--teal); border-bottom-color:var(--teal); }

/* ── NEXT MATCH BANNER ── */
.fx-next { background:linear-gradient(135deg,var(--teal2),var(--teal)); border-bottom:2px solid var(--mustard); padding:1.2rem 1.5rem; display:flex; align-items:center; gap:1.5rem; flex-wrap:wrap; }
.fx-next-countdown { text-align:center; min-width:70px; }
.fx-next-days { font-family:'Bebas Neue',sans-serif; font-size:2.8rem; letter-spacing:2px; color:var(--mustard); line-height:1; }
.fx-next-days-lbl { font-size:0.54rem; font-weight:800; letter-spacing:2px; text-transform:uppercase; color:rgba(255,255,255,0.45); }
.fx-next-divider { width:1px; height:60px; background:rgba(255,255,255,0.15); flex-shrink:0; }
.fx-next-match { flex:1; min-width:200px; }
.fx-next-comp { font-size:0.58rem; font-weight:800; letter-spacing:2.5px; text-transform:uppercase; color:rgba(255,255,255,0.45); margin-bottom:0.3rem; }
.fx-next-teams { font-family:'Bebas Neue',sans-serif; font-size:1.6rem; letter-spacing:2px; color:var(--white); line-height:1.1; }
.fx-next-details { font-size:0.68rem; color:rgba(255,255,255,0.5); font-weight:300; margin-top:0.3rem; }
.fx-next-badge { font-size:0.58rem; font-weight:800; padding:0.14rem 0.5rem; letter-spacing:2px; text-transform:uppercase; margin-right:0.35rem; }
.fx-next-badge.home { background:var(--mustard); color:var(--ink); }
.fx-next-badge.away { background:rgba(255,255,255,0.15); color:rgba(255,255,255,0.7); }
.fx-next-actions { display:flex; gap:0.5rem; flex-wrap:wrap; margin-left:auto; }
.fx-next-btn { padding:0.48rem 1rem; font-family:'DM Sans',sans-serif; font-size:0.65rem; font-weight:800; letter-spacing:1.5px; text-transform:uppercase; cursor:pointer; border:1.5px solid rgba(255,255,255,0.3); color:rgba(255,255,255,0.7); background:transparent; transition:all 0.2s; }
.fx-next-btn:hover { border-color:var(--mustard); color:var(--mustard); }
.fx-next-btn.primary { background:var(--mustard); border-color:var(--mustard); color:var(--ink); }

/* ── FIXTURE LIST ── */
.fx-body { padding:1.2rem 1.5rem; }
.fx-month-header { font-family:'Bebas Neue',sans-serif; font-size:0.85rem; letter-spacing:3px; color:var(--muted); margin:1.2rem 0 0.6rem; padding-bottom:0.4rem; border-bottom:1.5px solid var(--rule); display:flex; align-items:center; gap:0.75rem; }
.fx-month-count { font-family:'DM Sans',sans-serif; font-size:0.58rem; font-weight:700; letter-spacing:1.5px; text-transform:uppercase; color:var(--muted); }

.fx-card { background:var(--white); border:1.5px solid var(--rule); margin-bottom:0.55rem; display:flex; align-items:stretch; cursor:pointer; transition:all 0.18s; position:relative; overflow:hidden; }
.fx-card:hover { border-color:var(--ink); box-shadow:3px 3px 0 rgba(0,0,0,0.08); }
.fx-card.next-match { border-color:var(--teal); border-left:4px solid var(--teal); }
.fx-card.played { opacity:0.8; }
.fx-card.played:hover { opacity:1; }

/* Fixture date col */
.fx-date-col { background:var(--cream2); padding:0.75rem 0.9rem; text-align:center; min-width:70px; display:flex; flex-direction:column; align-items:center; justify-content:center; border-right:1.5px solid var(--rule); flex-shrink:0; }
.fx-date-day { font-family:'Bebas Neue',sans-serif; font-size:1.5rem; letter-spacing:1px; color:var(--ink); line-height:1; }
.fx-date-month { font-size:0.58rem; font-weight:800; letter-spacing:2px; text-transform:uppercase; color:var(--muted); }
.fx-date-dow { font-size:0.58rem; color:var(--muted); font-weight:400; margin-top:0.15rem; }

/* Fixture main col */
.fx-main-col { flex:1; padding:0.75rem 1rem; display:flex; flex-direction:column; justify-content:center; }
.fx-comp-badge { font-size:0.54rem; font-weight:800; padding:0.08rem 0.4rem; letter-spacing:2px; text-transform:uppercase; margin-bottom:0.3rem; display:inline-block; }
.fx-comp-badge.league { background:var(--teal4); color:var(--teal); border:1px solid var(--teal3); }
.fx-comp-badge.cup { background:var(--mustard3); color:var(--mustard2); border:1px solid #f5dfa0; }
.fx-comp-badge.friendly { background:var(--cream2); color:var(--muted); border:1px solid var(--rule); }
.fx-opp { font-family:'DM Sans',sans-serif; font-size:0.95rem; font-weight:800; color:var(--ink); }
.fx-venue { font-size:0.65rem; color:var(--muted); font-weight:400; margin-top:0.1rem; }
.fx-venue strong { color:var(--ink2); font-weight:700; }
.fx-kickoff { font-size:0.62rem; color:var(--muted); margin-top:0.08rem; }

/* Result col */
.fx-result-col { padding:0.75rem 1rem; display:flex; flex-direction:column; align-items:center; justify-content:center; min-width:80px; border-left:1.5px solid var(--rule); flex-shrink:0; }
.fx-score { font-family:'Bebas Neue',sans-serif; font-size:1.6rem; letter-spacing:2px; line-height:1; }
.fx-score.W { color:#16a34a; }
.fx-score.D { color:var(--mustard); }
.fx-score.L { color:var(--darkred); }
.fx-result-badge { font-size:0.56rem; font-weight:800; padding:0.1rem 0.45rem; letter-spacing:2px; text-transform:uppercase; margin-top:0.2rem; }
.fx-result-badge.W { background:#dcfce7; color:#16a34a; border:1px solid #bbf7d0; }
.fx-result-badge.D { background:var(--mustard3); color:var(--mustard2); border:1px solid #f5dfa0; }
.fx-result-badge.L { background:var(--darkred3); color:var(--darkred); border:1px solid #f5b8b8; }
.fx-upcoming-col { padding:0.75rem 1rem; display:flex; flex-direction:column; align-items:center; justify-content:center; min-width:90px; border-left:1.5px solid var(--rule); flex-shrink:0; gap:0.3rem; }

/* Prep status indicator */
.fx-prep-dot { width:8px; height:8px; border-radius:50%; flex-shrink:0; }
.fx-prep-done { background:#16a34a; }
.fx-prep-part { background:var(--mustard); }
.fx-prep-none { background:var(--cream2); border:1.5px solid var(--rule); }

/* ── MATCH PREP SCREEN ── */
.fx-prep-wrap { padding:1.2rem 1.5rem; }
.fx-prep-header { background:var(--white); border:1.5px solid var(--rule); border-top:4px solid var(--teal); margin-bottom:1.2rem; }
.fx-prep-header-top { padding:1.1rem 1.2rem; display:flex; align-items:flex-start; justify-content:space-between; flex-wrap:wrap; gap:0.75rem; border-bottom:1.5px solid var(--rule); }
.fx-prep-opp { font-family:'Bebas Neue',sans-serif; font-size:1.5rem; letter-spacing:2px; color:var(--ink); }
.fx-prep-meta { font-size:0.65rem; color:var(--muted); margin-top:0.15rem; }
.fx-prep-grid { display:grid; grid-template-columns:1fr 1fr 1fr; gap:0; }
.fx-prep-cell { padding:0.65rem 1rem; border-right:1.5px solid var(--rule); }
.fx-prep-cell:last-child { border-right:none; }
.fx-prep-cell-lbl { font-size:0.55rem; font-weight:800; letter-spacing:2px; text-transform:uppercase; color:var(--muted); margin-bottom:0.2rem; }
.fx-prep-cell-val { font-family:'Bebas Neue',sans-serif; font-size:1.1rem; letter-spacing:1.5px; color:var(--ink); }

/* Prep checklist */
.fx-prep-checklist { background:var(--white); border:1.5px solid var(--rule); margin-bottom:1rem; }
.fx-prep-check-header { padding:0.75rem 1rem; border-bottom:1.5px solid var(--rule); display:flex; align-items:center; justify-content:space-between; }
.fx-prep-check-title { font-family:'Bebas Neue',sans-serif; font-size:0.88rem; letter-spacing:2px; color:var(--ink); }
.fx-prep-check-progress { font-size:0.65rem; font-weight:700; color:var(--teal); }
.fx-check-item { display:flex; align-items:center; gap:0.75rem; padding:0.62rem 1rem; border-bottom:1px solid var(--rule2); cursor:pointer; transition:all 0.15s; }
.fx-check-item:last-child { border-bottom:none; }
.fx-check-item:hover { background:var(--teal4); }
.fx-check-item.done { opacity:0.65; }
.fx-check-box { width:20px; height:20px; border:2px solid var(--rule); flex-shrink:0; display:flex; align-items:center; justify-content:center; transition:all 0.15s; }
.fx-check-box.done { background:var(--teal); border-color:var(--teal); }
.fx-check-box-tick { color:white; font-size:0.75rem; font-weight:800; }
.fx-check-label { font-size:0.8rem; font-weight:600; color:var(--ink); flex:1; }
.fx-check-label.done { text-decoration:line-through; color:var(--muted); }
.fx-check-sub { font-size:0.65rem; color:var(--muted); font-weight:300; }
.fx-check-link { font-size:0.62rem; font-weight:800; color:var(--teal); letter-spacing:1px; text-transform:uppercase; cursor:pointer; }

/* ── TEAM SELECTION ── */
.fx-team-wrap { display:grid; grid-template-columns:1fr 300px; gap:1.2rem; margin-bottom:1.2rem; }
.fx-pitch-container { background:var(--white); border:1.5px solid var(--rule); }
.fx-pitch-head { padding:0.75rem 1rem; border-bottom:1.5px solid var(--rule); display:flex; align-items:center; justify-content:space-between; }
.fx-pitch-title { font-family:'Bebas Neue',sans-serif; font-size:0.88rem; letter-spacing:2px; color:var(--ink); }
.fx-pitch { background:linear-gradient(180deg,#3a6b42,#4a7c52 30%,#3d6e45 50%,#4a7c52 70%,#3a6b42); height:380px; position:relative; }
.fx-formation-select { background:var(--cream2); border:1.5px solid var(--rule); border-bottom:2px solid var(--teal); padding:0.35rem 0.65rem; font-family:'DM Sans',sans-serif; font-size:0.75rem; font-weight:700; outline:none; cursor:pointer; }

/* Pitch slots */
.fx-pitch-slot { position:absolute; transform:translate(-50%,-50%); cursor:pointer; }
.fx-pitch-token { width:48px; height:48px; border-radius:50%; display:flex; flex-direction:column; align-items:center; justify-content:center; border:2.5px solid rgba(255,255,255,0.6); transition:all 0.2s; }
.fx-pitch-token:hover { transform:scale(1.12); border-color:var(--mustard); }
.fx-pitch-token.filled { border-color:var(--mustard); }
.fx-pitch-token.empty { background:rgba(255,255,255,0.1); border-style:dashed; border-color:rgba(255,255,255,0.3); }
.fx-pitch-token .tok-pos { font-size:0.48rem; font-weight:800; color:rgba(255,255,255,0.7); letter-spacing:1px; }
.fx-pitch-token .tok-name { font-size:0.52rem; font-weight:800; color:white; line-height:1.1; max-width:42px; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; text-align:center; }
.fx-pitch-token .tok-ovr { font-family:'Bebas Neue',sans-serif; font-size:0.7rem; color:var(--mustard); letter-spacing:1px; }
.fx-pitch-gk .fx-pitch-token { background:#b45309; }
.fx-pitch-def .fx-pitch-token { background:var(--darkred); }
.fx-pitch-mid .fx-pitch-token { background:var(--teal); }
.fx-pitch-att .fx-pitch-token { background:#16a34a; }

/* Subs panel */
.fx-subs-panel { background:var(--white); border:1.5px solid var(--rule); }
.fx-subs-head { padding:0.75rem 1rem; border-bottom:1.5px solid var(--rule); }
.fx-subs-title { font-family:'Bebas Neue',sans-serif; font-size:0.88rem; letter-spacing:2px; color:var(--ink); }
.fx-subs-list { overflow-y:auto; max-height:320px; }
.fx-sub-row { display:flex; align-items:center; gap:0.55rem; padding:0.48rem 0.9rem; border-bottom:1px solid var(--rule2); cursor:pointer; transition:all 0.15s; }
.fx-sub-row:hover { background:var(--teal4); }
.fx-sub-row.in-xi { background:var(--teal4); border-left:3px solid var(--teal); }
.fx-sub-av { width:28px; height:28px; border-radius:50%; display:flex; align-items:center; justify-content:center; font-size:0.6rem; font-weight:800; color:white; flex-shrink:0; }
.fx-sub-name { font-size:0.78rem; font-weight:700; color:var(--ink); flex:1; }
.fx-sub-pos { font-size:0.58rem; font-weight:800; padding:0.06rem 0.32rem; letter-spacing:1px; text-transform:uppercase; }
.fx-sub-ovr { font-family:'Bebas Neue',sans-serif; font-size:0.88rem; letter-spacing:1px; color:var(--muted); }

/* ── RESULTS / FORM ── */
.fx-results-header { display:flex; align-items:center; justify-content:space-between; margin-bottom:0.85rem; }
.fx-results-title { font-family:'Bebas Neue',sans-serif; font-size:1rem; letter-spacing:2.5px; color:var(--ink); }
.fx-form-strip { display:flex; gap:0.4rem; }
.fx-form-badge { width:28px; height:28px; border-radius:50%; display:flex; align-items:center; justify-content:center; font-family:'Bebas Neue',sans-serif; font-size:0.8rem; letter-spacing:1px; }
.fx-form-badge.W { background:#16a34a; color:white; }
.fx-form-badge.D { background:var(--mustard); color:var(--ink); }
.fx-form-badge.L { background:var(--darkred); color:white; }

/* ── LEAGUE TABLE ── */
.fx-table { background:var(--white); border:1.5px solid var(--rule); margin-bottom:1.2rem; }
.fx-table-header { padding:0.75rem 1rem; border-bottom:1.5px solid var(--rule); display:flex; align-items:center; gap:0.75rem; }
.fx-table-title { font-family:'Bebas Neue',sans-serif; font-size:0.88rem; letter-spacing:2px; color:var(--ink); }
.fx-league-table { width:100%; border-collapse:collapse; }
.fx-league-table th { background:var(--ink); color:rgba(255,255,255,0.55); font-family:'DM Sans',sans-serif; font-size:0.58rem; font-weight:800; letter-spacing:2px; text-transform:uppercase; padding:0.42rem 0.75rem; text-align:center; }
.fx-league-table th:first-child,.fx-league-table th:nth-child(2) { text-align:left; }
.fx-league-table td { padding:0.48rem 0.75rem; border-bottom:1px solid var(--rule2); font-size:0.8rem; text-align:center; }
.fx-league-table td:nth-child(2) { text-align:left; font-weight:700; color:var(--ink); }
.fx-league-table tr.my-team td { background:var(--teal4); border-left:3px solid var(--teal); }
.fx-league-table tr.my-team td:first-child { padding-left:calc(0.75rem - 3px); }
.fx-pos-num { font-family:'Bebas Neue',sans-serif; font-size:0.9rem; letter-spacing:1px; color:var(--muted); }
.fx-pos-num.top { color:var(--teal); font-weight:800; }
.fx-pts { font-family:'Bebas Neue',sans-serif; font-size:0.9rem; letter-spacing:1px; color:var(--ink); }

/* ── ADD FIXTURE MODAL ── */
.fx-modal-bg { position:fixed; inset:0; background:rgba(0,0,0,0.55); z-index:200; display:flex; align-items:center; justify-content:center; padding:1.5rem; }
.fx-modal { background:var(--white); border:2.5px solid var(--ink); width:100%; max-width:480px; box-shadow:8px 8px 0 rgba(0,0,0,0.2); max-height:85vh; overflow-y:auto; }
.fx-modal-head { background:var(--teal2); padding:1rem 1.2rem; border-bottom:2px solid var(--mustard); display:flex; align-items:center; justify-content:space-between; }
.fx-modal-title { font-family:'Bebas Neue',sans-serif; font-size:1rem; letter-spacing:2.5px; color:var(--white); }
.fx-modal-close { background:transparent; border:none; color:rgba(255,255,255,0.6); font-size:1.2rem; cursor:pointer; }
.fx-modal-body { padding:1.2rem; }
.fx-form-label { display:block; font-size:0.58rem; font-weight:800; letter-spacing:2px; text-transform:uppercase; color:var(--muted); margin-bottom:0.35rem; margin-top:0.75rem; }
.fx-form-label:first-child { margin-top:0; }
.fx-form-input { width:100%; background:var(--cream); border:1.5px solid var(--rule); border-bottom:2px solid var(--ink); padding:0.6rem 0.8rem; color:var(--ink); font-family:'DM Sans',sans-serif; font-size:0.85rem; font-weight:500; outline:none; }
.fx-form-input:focus { border-bottom-color:var(--teal); }
.fx-form-select { width:100%; background:var(--cream); border:1.5px solid var(--rule); border-bottom:2px solid var(--ink); padding:0.6rem 0.8rem; color:var(--ink); font-family:'DM Sans',sans-serif; font-size:0.85rem; font-weight:500; outline:none; cursor:pointer; }
.fx-form-row { display:grid; grid-template-columns:1fr 1fr; gap:0.75rem; }
.fx-modal-actions { display:flex; gap:0.6rem; margin-top:1.2rem; }
.fx-btn-p { flex:1; padding:0.72rem; background:var(--teal); color:var(--white); border:2px solid var(--teal); font-family:'DM Sans',sans-serif; font-weight:800; font-size:0.72rem; letter-spacing:2px; text-transform:uppercase; cursor:pointer; transition:all 0.2s; }
.fx-btn-p:hover { background:var(--teal2); }
.fx-btn-s { flex:1; padding:0.72rem; background:transparent; color:var(--ink); border:1.5px solid var(--rule); font-family:'DM Sans',sans-serif; font-weight:700; font-size:0.72rem; letter-spacing:2px; text-transform:uppercase; cursor:pointer; }

/* Add button */
.fx-add-btn { padding:0.48rem 1rem; background:var(--mustard); color:var(--ink); border:2px solid var(--mustard); font-family:'DM Sans',sans-serif; font-weight:800; font-size:0.68rem; letter-spacing:1.5px; text-transform:uppercase; cursor:pointer; transition:all 0.2s; }
.fx-add-btn:hover { background:var(--mustard2); }

/* Empty */
.fx-empty { text-align:center; padding:4rem 2rem; }
.fx-empty-icon { font-size:3rem; margin-bottom:1rem; }
.fx-empty-title { font-family:'Bebas Neue',sans-serif; font-size:1.6rem; letter-spacing:2px; margin-bottom:0.5rem; }
.fx-empty-sub { font-size:0.82rem; color:var(--muted); font-style:italic; font-weight:300; max-width:380px; margin:0 auto; line-height:1.7; }

@media(max-width:900px) {
  .fx-team-wrap { grid-template-columns:1fr; }
  .fx-prep-grid { grid-template-columns:1fr 1fr; }
  .fx-stat-strip { flex-wrap:wrap; }
  .fx-next { flex-wrap:wrap; gap:0.75rem; }
  .fx-next-actions { width:100%; }
  .fx-header-top { flex-wrap:wrap; }
  .fx-pitch { height:280px; }
  .fx-card { flex-wrap:wrap; }
}
@media(max-width:600px) {
  .fx-prep-grid { grid-template-columns:1fr; }
  .fx-stat { min-width:calc(50% - 1px); border-bottom:1px solid rgba(255,255,255,0.1); }
  .fx-body { padding:0.85rem; }
  .fx-prep-wrap { padding:0.85rem; }
  .fx-modal { padding:0.5rem; }
  .fx-form-row { grid-template-columns:1fr; }
}
`;

/* ── FORMATION SLOT POSITIONS ── */
const FORMATION_SLOTS = {
  "4-3-3": [
    {pos:"GK",x:50,y:88},{pos:"RB",x:80,y:72},{pos:"CB",x:62,y:75},{pos:"CB",x:38,y:75},{pos:"LB",x:20,y:72},
    {pos:"CM",x:72,y:52},{pos:"CM",x:50,y:48},{pos:"CM",x:28,y:52},
    {pos:"RW",x:78,y:28},{pos:"ST",x:50,y:20},{pos:"LW",x:22,y:28},
  ],
  "4-4-2": [
    {pos:"GK",x:50,y:88},{pos:"RB",x:80,y:72},{pos:"CB",x:62,y:75},{pos:"CB",x:38,y:75},{pos:"LB",x:20,y:72},
    {pos:"RM",x:82,y:50},{pos:"CM",x:60,y:50},{pos:"CM",x:40,y:50},{pos:"LM",x:18,y:50},
    {pos:"ST",x:62,y:22},{pos:"ST",x:38,y:22},
  ],
  "4-2-3-1": [
    {pos:"GK",x:50,y:88},{pos:"RB",x:80,y:72},{pos:"CB",x:62,y:75},{pos:"CB",x:38,y:75},{pos:"LB",x:20,y:72},
    {pos:"CDM",x:62,y:56},{pos:"CDM",x:38,y:56},
    {pos:"RW",x:78,y:36},{pos:"CAM",x:50,y:34},{pos:"LW",x:22,y:36},
    {pos:"ST",x:50,y:18},
  ],
  "3-5-2": [
    {pos:"GK",x:50,y:88},{pos:"CB",x:70,y:74},{pos:"CB",x:50,y:76},{pos:"CB",x:30,y:74},
    {pos:"RWB",x:88,y:55},{pos:"CM",x:68,y:50},{pos:"CM",x:50,y:46},{pos:"CM",x:32,y:50},{pos:"LWB",x:12,y:55},
    {pos:"ST",x:62,y:22},{pos:"ST",x:38,y:22},
  ],
  "3-4-3": [
    {pos:"GK",x:50,y:88},{pos:"CB",x:70,y:74},{pos:"CB",x:50,y:76},{pos:"CB",x:30,y:74},
    {pos:"RWB",x:85,y:52},{pos:"CM",x:62,y:48},{pos:"CM",x:38,y:48},{pos:"LWB",x:15,y:52},
    {pos:"RW",x:78,y:26},{pos:"ST",x:50,y:20},{pos:"LW",x:22,y:26},
  ],
  "4-1-4-1": [
    {pos:"GK",x:50,y:88},{pos:"RB",x:80,y:72},{pos:"CB",x:62,y:75},{pos:"CB",x:38,y:75},{pos:"LB",x:20,y:72},
    {pos:"CDM",x:50,y:60},
    {pos:"RM",x:82,y:44},{pos:"CM",x:62,y:42},{pos:"CM",x:38,y:42},{pos:"LM",x:18,y:44},
    {pos:"ST",x:50,y:18},
  ],
};

// Competition names for dropdown — pulled from real FootballData
const COMP_NAMES = COMPETITIONS.map(c => c.name);

/* ── HELPERS ── */
function daysUntil(dateStr) {
  const today = new Date(); today.setHours(0,0,0,0);
  const match = new Date(dateStr); match.setHours(0,0,0,0);
  return Math.round((match-today)/(1000*60*60*24));
}

function formatDate(dateStr) {
  const d = new Date(dateStr);
  return {
    day: d.getDate(),
    month: d.toLocaleString("en-GB",{month:"short"}).toUpperCase(),
    dow: d.toLocaleString("en-GB",{weekday:"short"}).toUpperCase(),
    full: d.toLocaleDateString("en-GB",{day:"numeric",month:"long",year:"numeric"}),
    monthYear: d.toLocaleString("en-GB",{month:"long",year:"numeric"}),
  };
}

function posGroupColor(pos) {
  if(pos==="GK") return "#b45309";
  if(["CB","RB","LB","WB","RWB","LWB"].includes(pos)) return "var(--darkred)";
  if(["CDM","CM","CAM","RM","LM","RWB","LWB"].includes(pos)) return "var(--teal)";
  return "#16a34a";
}

function ini(name) {
  return (name||"?").split(" ").map(w=>w[0]).join("").toUpperCase().slice(0,2);
}

function posGroup(pos) {
  if(pos==="GK") return "gk";
  if(["CB","RB","LB","WB","RWB","LWB"].includes(pos)) return "def";
  if(["CDM","CM","CAM","RM","LM"].includes(pos)) return "mid";
  return "att";
}

/* ── DEFAULT LEAGUE TABLE — starts empty, coach adds their own teams ── */
function defaultTable() {
  return [];
}

/* ══════════════════════════════════════
   MAIN COMPONENT
══════════════════════════════════════ */
export default function Fixtures({ squad = [], onNavigate = null }) {
  const toast = useToast();
  const [fixtures, setFixtures] = useState(() => loadFromStorage("fx_fixtures", null) || []);
  const [activeTab, setActiveTab] = useState("fixtures");
  const [showAddModal, setShowAddModal] = useState(false);
  const [selFixture, setSelFixture] = useState(null);
  const [prepView, setPrepView] = useState(false);
  const [formation, setFormation] = useState("4-3-3");
  const [xi, setXi] = useState({}); // slot index -> player id
  const [myClubName, setMyClubName] = useState(() => loadFromStorage("fx_club_name", "My Club"));
  const [showResultModal, setShowResultModal] = useState(false);
  const [playerRatings, setPlayerRatings] = useState({}); // playerId → rating 1-10
  const [resultForm, setResultForm] = useState({goalsFor:"",goalsAgainst:"",possession:"",pressEff:"",notes:""});
  const [leagueTeams, setLeagueTeams] = useState(() => loadFromStorage("fx_league_teams", null) || defaultTable());
  const [showEditTable, setShowEditTable] = useState(false);
  const [newTeamName, setNewTeamName] = useState("");

  // New fixture form
  const [newFx, setNewFx] = useState({opponent:"",venue:"home",competition:"National League",date:"",kickoff:"15:00"});

  // Save fixtures to localStorage whenever they change
  useEffect(() => { saveToStorage("fx_fixtures", fixtures); }, [fixtures]);
  useEffect(() => { saveToStorage("fx_league_teams", leagueTeams); }, [leagueTeams]);

  /* ── DERIVED DATA ── */
  const sortedFixtures = [...fixtures].sort((a,b) => new Date(a.date) - new Date(b.date));
  const upcoming = sortedFixtures.filter(f => !f.played);
  const played = sortedFixtures.filter(f => f.played).reverse();
  const nextMatch = upcoming[0] || null;

  /* ── REAL LEAGUE TABLE — own stats from results, others from manual entry ── */
  const myStats = useMemo(() => {
    const leagueResults = played.filter(f=>
      f.competition==="National League" ||
      f.competition==="National League North" ||
      f.competition==="National League South" ||
      f.competition?.includes("Premier League") ||
      f.competition?.includes("Division")
    );
    return {
      P: leagueResults.length,
      W: leagueResults.filter(f=>f.goalsFor>f.goalsAgainst).length,
      D: leagueResults.filter(f=>f.goalsFor===f.goalsAgainst).length,
      L: leagueResults.filter(f=>f.goalsFor<f.goalsAgainst).length,
      GF: leagueResults.reduce((s,f)=>s+(f.goalsFor||0),0),
      GA: leagueResults.reduce((s,f)=>s+(f.goalsAgainst||0),0),
    };
  },[played]);

  const table = useMemo(() => {
    const myRow = { name:myClubName, ...myStats, GD:myStats.GF-myStats.GA, Pts:myStats.W*3+myStats.D, isMe:true };
    const others = leagueTeams.map(t=>({...t, GD:t.GF-t.GA, Pts:t.W*3+t.D}));
    return [myRow, ...others].sort((a,b)=>b.Pts-a.Pts||b.GD-a.GD);
  },[myClubName,myStats,leagueTeams]);

  const stats = useMemo(() => {
    const results = played;
    const W = results.filter(f => f.goalsFor > f.goalsAgainst).length;
    const D = results.filter(f => f.goalsFor === f.goalsAgainst).length;
    const L = results.filter(f => f.goalsFor < f.goalsAgainst).length;
    const GF = results.reduce((s,f) => s+f.goalsFor,0);
    const GA = results.reduce((s,f) => s+f.goalsAgainst,0);
    return { P:results.length, W, D, L, GF, GA, Pts:W*3+D };
  }, [played]);

  const form = played.slice(0,5).map(f => f.goalsFor > f.goalsAgainst?"W":f.goalsFor===f.goalsAgainst?"D":"L");

  /* ── PREP CHECKLIST ITEMS ── */
  const PREP_ITEMS = [
    {key:"dossier",   label:"Opposition Dossier",   sub:"Research their style, threats and set pieces", link:"dossier"},
    {key:"tactics",   label:"Tactical Plan",         sub:"Set your formation and roles on the Tactics Board", link:"tacticsboard"},
    {key:"training",  label:"Training Session",      sub:"Design a session focused on the match preparation", link:"squadcoach"},
    {key:"setpieces", label:"Set Piece Routines",    sub:"Build your corners and free kick routines", link:"setpiece"},
    {key:"teamTalk",  label:"Match Day Team Talk",   sub:"Prepare your team talk notes", link:null},
  ];

  /* ── ADD FIXTURE ── */
  const addFixture = () => {
    if(!newFx.opponent||!newFx.date) return;
    const fx = {
      id: Date.now(),
      ...newFx,
      played:false,
      prep:{dossier:false,tactics:false,teamTalk:false,setpieces:false,training:false}
    };
    setFixtures(prev => [...prev, fx]);
    setNewFx({opponent:"",venue:"home",competition:"National League",date:"",kickoff:"15:00"});
    setShowAddModal(false);
    toast && toast(`vs ${fx.opponent} added to fixtures`, "success");
  };

  /* ── LOG RESULT ── */
  const logResult = () => {
    if(!selFixture||resultForm.goalsFor===""||resultForm.goalsAgainst==="") return;
    const gf = Number(resultForm.goalsFor);
    const ga = Number(resultForm.goalsAgainst);
    const res = gf>ga?"Win":gf<ga?"Loss":"Draw";
    setFixtures(prev => prev.map(f => f.id===selFixture.id ? {
      ...f, played:true,
      goalsFor:gf,
      goalsAgainst:ga,
      possession:Number(resultForm.possession)||50,
      pressEff:Number(resultForm.pressEff)||65,
      notes:resultForm.notes,
      playerRatings,
    } : f));

    // Persist player ratings to a dedicated store — used by player profiles
    const existing = loadFromStorage("player_match_ratings", []) || [];
    const matchRecord = {
      fixtureId: selFixture.id,
      opponent:  selFixture.opponent,
      date:      selFixture.date,
      result:    res,
      score:     `${gf}–${ga}`,
      ratings:   playerRatings,
      loggedAt:  new Date().toISOString(),
    };
    saveToStorage("player_match_ratings", [matchRecord, ...existing].slice(0, 100));

    setShowResultModal(false);
    setPlayerRatings({});
    setResultForm({goalsFor:"",goalsAgainst:"",possession:"",pressEff:"",notes:""});
    toast && toast(`Result logged: ${res} ${gf}–${ga} vs ${selFixture.opponent}`, gf>ga?"success":gf<ga?"error":"info");
    setSelFixture(null);
  };

  /* ── TOGGLE PREP ITEM ── */
  const togglePrep = (fixtureId, key) => {
    setFixtures(prev => prev.map(f => f.id===fixtureId ? {...f, prep:{...f.prep, [key]:!f.prep[key]}} : f));
  };

  /* ── XI MANAGEMENT ── */
  const slots = FORMATION_SLOTS[formation] || FORMATION_SLOTS["4-3-3"];
  const xiPlayers = Object.values(xi).map(id => squad.find(p=>String(p.id)===String(id))).filter(Boolean);

  /* ── GROUP FIXTURES BY MONTH ── */
  const groupedUpcoming = useMemo(() => {
    const groups = {};
    upcoming.forEach(f => {
      const key = formatDate(f.date).monthYear;
      if(!groups[key]) groups[key] = [];
      groups[key].push(f);
    });
    return groups;
  }, [upcoming]);

  /* ═══ PREP VIEW ═══ */
  if(prepView && selFixture) {
    const daysAway = daysUntil(selFixture.date);
    const prepCount = selFixture.prep ? Object.values(selFixture.prep).filter(Boolean).length : 0;
    const totalPrep = PREP_ITEMS.length;

    return (
      <>
        <style>{FX_CSS}</style>
        <div className="fx-wrap">
          {/* Header */}
          <div className="fx-header">
            <div className="fx-header-top">
              <div>
                <button onClick={()=>{setPrepView(false);setSelFixture(null);}} style={{background:"transparent",border:"none",color:"rgba(255,255,255,0.6)",cursor:"pointer",fontFamily:"'DM Sans',sans-serif",fontSize:"0.68rem",fontWeight:700,letterSpacing:"1px",padding:0,marginBottom:"0.4rem",display:"flex",alignItems:"center",gap:"0.35rem"}}>
                  ← Back to Fixtures
                </button>
                <div className="fx-header-title">Match Prep — {selFixture.opponent}</div>
                <div className="fx-header-sub">
                  {formatDate(selFixture.date).full} · {selFixture.kickoff} · {selFixture.venue==="home"?"Home":"Away"} · {selFixture.competition}
                </div>
              </div>
              <div style={{display:"flex",gap:"0.5rem",alignItems:"flex-start"}}>
                <div style={{textAlign:"center"}}>
                  <div style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:"2.2rem",letterSpacing:"2px",color:daysAway<=3?"#f87171":daysAway<=7?"var(--mustard)":"#4ade80",lineHeight:1}}>{daysAway}</div>
                  <div style={{fontSize:"0.52rem",fontWeight:800,letterSpacing:"2px",textTransform:"uppercase",color:"rgba(255,255,255,0.45)"}}>Days Away</div>
                </div>
              </div>
            </div>
          </div>

          <div className="fx-prep-wrap">
            {/* Match info bar */}
            <div className="fx-prep-header">
              <div className="fx-prep-header-top">
                <div>
                  <div style={{display:"flex",gap:"0.4rem",marginBottom:"0.35rem"}}>
                    <span className={`fx-comp-badge ${selFixture.competition==="League"?"league":selFixture.competition.includes("Cup")?"cup":"friendly"}`}>{selFixture.competition}</span>
                    <span className={`fx-next-badge ${selFixture.venue}`}>{selFixture.venue==="home"?"Home":"Away"}</span>
                  </div>
                  <div className="fx-prep-opp">vs {selFixture.opponent}</div>
                  <div className="fx-prep-meta">{formatDate(selFixture.date).full} · Kick-off {selFixture.kickoff}</div>
                </div>
                <div style={{display:"flex",gap:"0.5rem"}}>
                  <button onClick={()=>{setResultForm({goalsFor:"",goalsAgainst:"",possession:"",pressEff:"",notes:""});setShowResultModal(true);}} style={{padding:"0.45rem 0.9rem",background:"var(--mustard)",color:"var(--ink)",border:"none",fontFamily:"'DM Sans',sans-serif",fontWeight:800,fontSize:"0.65rem",letterSpacing:"1.5px",textTransform:"uppercase",cursor:"pointer"}}>
                    Log Result
                  </button>
                  <ExportButton onClick={()=>exportMatchPrepPDF(selFixture,squad)} label="Print Prep" small/>
                  <ExportButton onClick={()=>{
                    const profile = loadFromStorage(`profile_${squad[0]?.userId||""}`,{}) || loadFromStorage("profile_pending",{}) || {};
                    const dossier = loadFromStorage("saved_dossiers",[])?.find(d=>d.oppName===selFixture.opponent) || null;
                    exportPreMatchPack({
                      fixture:selFixture,
                      squad,
                      formation:loadFromStorage("tactics_board_state",{})?.formation||"4-3-3",
                      tacticsState:loadFromStorage("tactics_board_state",null),
                      dossier,
                      clubName:loadFromStorage("fx_club_name","My Club"),
                      profile,
                    });
                  }} label="📋 Pre-Match Pack" small/>
                </div>
              </div>
              <div className="fx-prep-grid">
                <div className="fx-prep-cell">
                  <div className="fx-prep-cell-lbl">Prep Progress</div>
                  <div className="fx-prep-cell-val" style={{color:prepCount===totalPrep?"#16a34a":prepCount>0?"var(--mustard)":"var(--muted)"}}>{prepCount}/{totalPrep} Complete</div>
                </div>
                <div className="fx-prep-cell">
                  <div className="fx-prep-cell-lbl">Days Until Match</div>
                  <div className="fx-prep-cell-val" style={{color:daysAway<=3?"var(--darkred)":daysAway<=7?"var(--mustard)":"var(--teal)"}}>{daysAway} days</div>
                </div>
                <div className="fx-prep-cell">
                  <div className="fx-prep-cell-lbl">Squad Available</div>
                  <div className="fx-prep-cell-val" style={{color:squad.filter(p=>{const d=loadFromStorage("load_management",{})?.[p.id];return !d||d.status==="available";}).length<squad.length*0.8?"var(--darkred)":"var(--teal)"}}>
                    {squad.filter(p=>{const d=loadFromStorage("load_management",{})?.[p.id];return !d||d.status==="available";}).length}/{squad.length} players
                  </div>
                </div>
              </div>
            </div>

            {/* Checklist */}
            <div className="fx-prep-checklist">
              <div className="fx-prep-check-header">
                <div className="fx-prep-check-title">Preparation Checklist</div>
                <div className="fx-prep-check-progress">{prepCount}/{totalPrep} done</div>
              </div>
              {PREP_ITEMS.map(item => {
                const done = selFixture.prep?.[item.key] || false;
                return (
                  <div key={item.key} className={`fx-check-item ${done?"done":""}`} onClick={()=>togglePrep(selFixture.id,item.key)}>
                    <div className={`fx-check-box ${done?"done":""}`}>
                      {done&&<span className="fx-check-box-tick">✓</span>}
                    </div>
                    <div style={{flex:1}}>
                      <div className={`fx-check-label ${done?"done":""}`}>{item.label}</div>
                      <div className="fx-check-sub">{item.sub}</div>
                    </div>
                    {item.link&&!done&&(
                      <span className="fx-check-link" onClick={e=>{e.stopPropagation();onNavigate&&onNavigate(item.link);}}>
                        Open →
                      </span>
                    )}
                  </div>
                );
              })}
            </div>

            {/* Team selection */}
            <div style={{background:"var(--white)",border:"1.5px solid var(--rule)",marginBottom:"1.2rem"}}>
              <div className="fx-pitch-head">
                <div className="fx-pitch-title">Team Selection</div>
                <div style={{display:"flex",gap:"0.5rem",alignItems:"center"}}>
                  <span style={{fontFamily:"'DM Sans',sans-serif",fontSize:"0.62rem",color:"var(--muted)"}}>Formation:</span>
                  <select className="fx-formation-select" value={formation} onChange={e=>{setFormation(e.target.value);setXi({});}}>
                    {Object.keys(FORMATION_SLOTS).map(f=><option key={f}>{f}</option>)}
                  </select>
                </div>
              </div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 260px"}}>
                {/* Pitch */}
                <div className="fx-pitch">
                  {/* SVG markings */}
                  <svg viewBox="0 0 100 100" preserveAspectRatio="none" style={{position:"absolute",inset:0,width:"100%",height:"100%",opacity:0.2}}>
                    <rect x="5" y="5" width="90" height="90" fill="none" stroke="white" strokeWidth=".5"/>
                    <line x1="5" y1="50" x2="95" y2="50" stroke="white" strokeWidth=".5"/>
                    <circle cx="50" cy="50" r="12" fill="none" stroke="white" strokeWidth=".5"/>
                    <rect x="22" y="5" width="56" height="18" fill="none" stroke="white" strokeWidth=".5"/>
                    <rect x="22" y="77" width="56" height="18" fill="none" stroke="white" strokeWidth=".5"/>
                    <rect x="34" y="5" width="32" height="8" fill="none" stroke="white" strokeWidth=".4"/>
                    <rect x="34" y="87" width="32" height="8" fill="none" stroke="white" strokeWidth=".4"/>
                  </svg>
                  {slots.map((slot,i) => {
                    const pid = xi[i];
                    const player = squad.find(p=>String(p.id)===String(pid));
                    const grp = posGroup(slot.pos);
                    return (
                      <div key={i} className={`fx-pitch-slot fx-pitch-${grp}`}
                        style={{left:`${slot.x}%`,top:`${slot.y}%`}}
                        onClick={()=>{
                          // Read live availability from load_management
                          const loadData = loadFromStorage("load_management",{}) || {};
                          const isAvail = p => {
                            const d = loadData[p.id];
                            return !d || (d.status==="available" || d.status==="knock");
                          };
                          const available = squad.filter(isAvail);
                          const posPlayers = available.filter(p=>posGroup(p.pos)===grp||p.pos===slot.pos);
                          const pool = posPlayers.length>0?posPlayers:available;
                          if(pool.length===0) return;
                          const currentIdx = pool.findIndex(p=>String(p.id)===String(pid));
                          const next = pool[(currentIdx+1)%pool.length];
                          setXi(prev=>({...prev,[i]:next.id}));
                        }}>
                        <div className={`fx-pitch-token ${player?"filled":"empty"}`}>
                          {player?(
                            <>
                              <div className="tok-pos">{player.pos}</div>
                              <div className="tok-name">{player.name.split(" ")[0]}</div>
                              <div className="tok-ovr">{player.overall}</div>
                            </>
                          ):(
                            <>
                              <div className="tok-pos">{slot.pos}</div>
                              <div style={{fontSize:"1rem",color:"rgba(255,255,255,0.3)"}}>+</div>
                            </>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
                {/* Squad list */}
                <div style={{borderLeft:"1.5px solid var(--rule)",display:"flex",flexDirection:"column"}}>
                  <div style={{padding:"0.55rem 0.9rem",borderBottom:"1.5px solid var(--rule)",fontFamily:"'Bebas Neue',sans-serif",fontSize:"0.78rem",letterSpacing:"2px",color:"var(--ink)"}}>
                    Squad — Click Position to Assign
                  </div>
                  <div className="fx-subs-list">
                    {squad.length===0?(
                      <div style={{padding:"1.5rem",textAlign:"center",fontFamily:"'DM Sans',sans-serif",fontSize:"0.75rem",color:"var(--muted)",fontStyle:"italic"}}>
                        Build your squad first
                      </div>
                    ):(() => {
                      const loadData = loadFromStorage("load_management",{}) || {};
                      return squad.map(p=>{
                        const inXI = Object.values(xi).some(id=>String(id)===String(p.id));
                        const ld = loadData[p.id];
                        const status = ld?.status || "available";
                        const isUnavail = status==="injured"||status==="suspended";
                        const statusLabel = status==="available"?"":status==="knock"?"Knock":status==="recovery"?"Recovery":status==="injured"?"Injured":"Suspended";
                        const statusColor = status==="injured"?"var(--darkred)":status==="suspended"?"#7c3aed":status==="knock"||status==="recovery"?"var(--mustard)":"var(--muted)";
                        return(
                          <div key={p.id} className={`fx-sub-row ${inXI?"in-xi":""}`} style={isUnavail?{opacity:0.55,background:"var(--darkred3)"}:{}}>
                            <div className="fx-sub-av" style={{background:posGroupColor(p.pos),border:isUnavail?"2px solid var(--darkred)":""}}>{ini(p.name)}</div>
                            <div style={{flex:1,minWidth:0}}>
                              <div className="fx-sub-name" style={{overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",color:isUnavail?"var(--muted)":"var(--ink)"}}>{p.name}</div>
                              {statusLabel&&<div style={{fontSize:"0.56rem",color:statusColor,fontWeight:800,letterSpacing:"1px",textTransform:"uppercase"}}>{statusLabel}{ld?.injuryType?` · ${ld.injuryType}`:""}</div>}
                            </div>
                            <span className="fx-sub-pos" style={{background:posGroupColor(p.pos),color:"white",padding:"0.06rem 0.3rem"}}>{p.pos}</span>
                            <div className="fx-sub-ovr" style={{color:isUnavail?"var(--muted)":"var(--ink)"}}>{p.overall}</div>
                            {inXI&&<span style={{fontSize:"0.62rem",color:"var(--teal)",fontWeight:800}}>XI</span>}
                            {isUnavail&&<span style={{fontSize:"0.7rem"}} title={statusLabel}>🚫</span>}
                          </div>
                        );
                      });
                    })()}
                  </div>
                </div>
              </div>
            </div>

            {/* Match notes */}
            <div style={{background:"var(--white)",border:"1.5px solid var(--rule)",padding:"1rem"}}>
              <div style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:"0.88rem",letterSpacing:"2px",color:"var(--ink)",marginBottom:"0.65rem"}}>Match Notes & Team Talk</div>
              <textarea
                style={{width:"100%",background:"var(--cream)",border:"1.5px solid var(--rule)",borderBottom:"2px solid var(--teal)",padding:"0.7rem 0.85rem",fontFamily:"'DM Sans',sans-serif",fontSize:"0.8rem",fontWeight:400,color:"var(--ink)",outline:"none",resize:"vertical",minHeight:120,fontStyle:"italic"}}
                placeholder="Pre-match notes, team talk points, specific instructions for this match..."
                defaultValue={selFixture.notes||""}
              />
              <button
                onClick={()=>onNavigate&&onNavigate("ai")}
                style={{marginTop:"0.65rem",padding:"0.5rem 1rem",background:"linear-gradient(135deg,var(--teal2),var(--teal))",color:"var(--white)",border:"none",fontFamily:"'DM Sans',sans-serif",fontWeight:800,fontSize:"0.65rem",letterSpacing:"1.5px",textTransform:"uppercase",cursor:"pointer"}}>
                ✦ Generate AI Opposition Report
              </button>
            </div>
          </div>

          {/* Result modal */}
          {showResultModal&&(
            <div className="fx-modal-bg" onClick={()=>setShowResultModal(false)}>
              <div className="fx-modal" onClick={e=>e.stopPropagation()}>
                <div className="fx-modal-head">
                  <div className="fx-modal-title">Log Result — {selFixture.opponent}</div>
                  <button className="fx-modal-close" onClick={()=>setShowResultModal(false)}>✕</button>
                </div>
                <div className="fx-modal-body">
                  <div className="fx-form-row">
                    <div>
                      <label className="fx-form-label">Our Goals</label>
                      <input className="fx-form-input" type="number" min="0" placeholder="0" value={resultForm.goalsFor} onChange={e=>setResultForm(p=>({...p,goalsFor:e.target.value}))}/>
                    </div>
                    <div>
                      <label className="fx-form-label">Their Goals</label>
                      <input className="fx-form-input" type="number" min="0" placeholder="0" value={resultForm.goalsAgainst} onChange={e=>setResultForm(p=>({...p,goalsAgainst:e.target.value}))}/>
                    </div>
                  </div>
                  <div className="fx-form-row">
                    <div>
                      <label className="fx-form-label">Possession %</label>
                      <input className="fx-form-input" type="number" min="0" max="100" placeholder="50" value={resultForm.possession} onChange={e=>setResultForm(p=>({...p,possession:e.target.value}))}/>
                    </div>
                    <div>
                      <label className="fx-form-label">Press Efficiency %</label>
                      <input className="fx-form-input" type="number" min="0" max="100" placeholder="65" value={resultForm.pressEff} onChange={e=>setResultForm(p=>({...p,pressEff:e.target.value}))}/>
                    </div>
                  </div>
                  <label className="fx-form-label">Match Notes</label>
                  <textarea className="fx-form-input" style={{resize:"vertical",minHeight:80,fontStyle:"italic"}} placeholder="Key moments, performance notes..." value={resultForm.notes} onChange={e=>setResultForm(p=>({...p,notes:e.target.value}))}/>

                  {/* Player ratings */}
                  {squad.length > 0 && (
                    <div style={{marginTop:"0.85rem"}}>
                      <div style={{fontFamily:"'DM Sans',sans-serif",fontSize:"0.58rem",fontWeight:800,letterSpacing:"2px",textTransform:"uppercase",color:"var(--muted)",marginBottom:"0.5rem"}}>
                        Player Ratings <span style={{fontWeight:400,textTransform:"none",fontStyle:"italic",letterSpacing:0,color:"var(--muted)"}}>— tap to rate</span>
                      </div>
                      <div style={{display:"flex",flexDirection:"column",gap:"0.28rem",maxHeight:220,overflowY:"auto"}}>
                        {squad.map(p => {
                          const r = playerRatings[p.id] || 0;
                          const rColor = r>=8?"#16a34a":r>=6?"var(--teal)":r>=5?"var(--mustard)":r>0?"var(--darkred)":"var(--rule)";
                          return (
                            <div key={p.id} style={{display:"flex",alignItems:"center",gap:"0.5rem"}}>
                              <div style={{fontFamily:"'DM Sans',sans-serif",fontSize:"0.72rem",fontWeight:700,color:"var(--ink)",width:140,flexShrink:0,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{p.name}</div>
                              <div style={{fontFamily:"'DM Sans',sans-serif",fontSize:"0.6rem",color:"var(--muted)",width:32,flexShrink:0}}>{p.pos}</div>
                              <div style={{display:"flex",gap:"0.18rem",flex:1}}>
                                {[1,2,3,4,5,6,7,8,9,10].map(n=>(
                                  <button key={n} onClick={()=>setPlayerRatings(prev=>({...prev,[p.id]:prev[p.id]===n?0:n}))}
                                    style={{flex:1,height:22,border:`1.5px solid ${r>=n?rColor:"var(--rule)"}`,background:r>=n?rColor:"transparent",cursor:"pointer",borderRadius:2,transition:"all 0.12s",fontSize:"0.55rem",fontFamily:"'DM Sans',sans-serif",fontWeight:800,color:r>=n?"white":"var(--muted)"}}>
                                    {n===10?"10":n}
                                  </button>
                                ))}
                              </div>
                              {r > 0 && <div style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:"1rem",letterSpacing:"1px",color:rColor,width:18,textAlign:"right",flexShrink:0}}>{r}</div>}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}
                  <div className="fx-modal-actions">
                    <button className="fx-btn-s" onClick={()=>setShowResultModal(false)}>Cancel</button>
                    <button className="fx-btn-p" onClick={logResult}>Save Result</button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </>
    );
  }

  /* ═══ MAIN FIXTURES VIEW ═══ */
  return (
    <>
      <style>{FX_CSS}</style>
      <div className="fx-wrap">

        {/* Header */}
        <div className="fx-header">
          <div className="fx-header-top">
            <div>
              <div style={{display:"flex",alignItems:"center",gap:"0.75rem"}}>
                <div className="fx-header-title">{myClubName}</div>
                <input
                  value={myClubName}
                  onChange={e=>{setMyClubName(e.target.value);saveToStorage("fx_club_name",e.target.value);}}
                  style={{background:"transparent",border:"none",borderBottom:"1px solid rgba(255,255,255,0.2)",color:"rgba(255,255,255,0.5)",fontFamily:"'DM Sans',sans-serif",fontSize:"0.68rem",outline:"none",padding:"0.1rem 0.3rem",width:140}}
                  placeholder="Edit club name..."
                />
              </div>
              <div className="fx-header-sub">{(()=>{const y=new Date().getFullYear();const m=new Date().getMonth();return m>=7?`${y}/${String(y+1).slice(2)}`:`${y-1}/${String(y).slice(2)}`;})()  } Season · {stats.P} matches played</div>
            </div>
            <button className="fx-add-btn" onClick={()=>setShowAddModal(true)}>+ Add Fixture</button>
          </div>
          <div className="fx-stat-strip">
            <div className="fx-stat"><div className="fx-stat-val">{stats.Pts}</div><div className="fx-stat-lbl">Points</div></div>
            <div className="fx-stat"><div className="fx-stat-val green">{stats.W}</div><div className="fx-stat-lbl">Won</div></div>
            <div className="fx-stat"><div className="fx-stat-val">{stats.D}</div><div className="fx-stat-lbl">Drawn</div></div>
            <div className="fx-stat"><div className="fx-stat-val red">{stats.L}</div><div className="fx-stat-lbl">Lost</div></div>
            <div className="fx-stat"><div className="fx-stat-val">{stats.GF}</div><div className="fx-stat-lbl">Goals For</div></div>
            <div className="fx-stat"><div className="fx-stat-val">{stats.GA}</div><div className="fx-stat-lbl">Goals Against</div></div>
          </div>
        </div>

        {/* Next match banner */}
        {nextMatch&&(
          <div className="fx-next">
            <div className="fx-next-countdown">
              <div className="fx-next-days">{Math.max(0,daysUntil(nextMatch.date))}</div>
              <div className="fx-next-days-lbl">Days</div>
            </div>
            <div className="fx-next-divider"/>
            <div className="fx-next-match">
              <div className="fx-next-comp">
                <span className="fx-next-badge next-comp">{nextMatch.competition}</span>
                Next Match
              </div>
              <div className="fx-next-teams">
                {myClubName} vs {nextMatch.opponent}
              </div>
              <div className="fx-next-details">
                <span className={`fx-next-badge ${nextMatch.venue}`}>{nextMatch.venue==="home"?"Home":"Away"}</span>
                {formatDate(nextMatch.date).full} · {nextMatch.kickoff}
              </div>
            </div>
            <div className="fx-form-dots" style={{flexShrink:0}}>
              {form.slice(0,5).map((r,i)=>(
                <div key={i} className={`fx-form-badge ${r}`}>{r}</div>
              ))}
            </div>
            <div className="fx-next-actions">
              <button className="fx-next-btn primary" onClick={()=>{setSelFixture(nextMatch);setPrepView(true);}}>
                Prepare for Match →
              </button>
              <button className="fx-next-btn" onClick={()=>onNavigate&&onNavigate("ai")}>
                ✦ AI Report
              </button>
            </div>
          </div>
        )}

        {/* Tabs */}
        <div className="fx-tabs">
          {[{id:"fixtures",l:"📅 Fixtures"},{id:"results",l:"📊 Results"},{id:"table",l:"🏆 League Table"}].map(t=>(
            <div key={t.id} className={`fx-tab ${activeTab===t.id?"on":""}`} onClick={()=>setActiveTab(t.id)}>{t.l}</div>
          ))}
        </div>

        <div className="fx-body">

          {/* ══ FIXTURES ══ */}
          {activeTab==="fixtures"&&(
            upcoming.length===0?(
              <div className="fx-empty">
                <div className="fx-empty-icon">📅</div>
                <div className="fx-empty-title">No Fixtures Scheduled</div>
                <div className="fx-empty-sub">Add your upcoming fixtures to start preparing for matches.</div>
                <button className="fx-add-btn" style={{marginTop:"1.5rem"}} onClick={()=>setShowAddModal(true)}>+ Add First Fixture</button>
              </div>
            ):(
              Object.entries(groupedUpcoming).map(([month, monthFixtures]) => (
                <div key={month}>
                  <div className="fx-month-header">
                    {month}
                    <span className="fx-month-count">{monthFixtures.length} fixture{monthFixtures.length!==1?"s":""}</span>
                  </div>
                  {monthFixtures.map((fx,i)=>{
                    const isNext = fx.id===nextMatch?.id;
                    const dAway = daysUntil(fx.date);
                    const prepCount = fx.prep ? Object.values(fx.prep).filter(Boolean).length : 0;
                    const fmtDate = formatDate(fx.date);
                    return(
                      <div key={fx.id} className={`fx-card ${isNext?"next-match":""}`} onClick={()=>{setSelFixture(fx);setPrepView(true);}}>
                        <div className="fx-date-col">
                          <div className="fx-date-day">{fmtDate.day}</div>
                          <div className="fx-date-month">{fmtDate.month}</div>
                          <div className="fx-date-dow">{fmtDate.dow}</div>
                        </div>
                        <div className="fx-main-col">
                          <span className={`fx-comp-badge ${fx.competition==="League"?"league":fx.competition.includes("Cup")?"cup":"friendly"}`}>{fx.competition}</span>
                          <div className="fx-opp">vs {fx.opponent}</div>
                          <div className="fx-venue"><strong>{fx.venue==="home"?"Home":"Away"}</strong> · {fx.kickoff}</div>
                        </div>
                        <div className="fx-upcoming-col">
                          {isNext&&<span style={{fontSize:"0.56rem",fontWeight:800,letterSpacing:"2px",textTransform:"uppercase",color:"var(--teal)",background:"var(--teal4)",padding:"0.1rem 0.4rem"}}>NEXT</span>}
                          <span style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:"0.85rem",letterSpacing:"1px",color:dAway<=3?"var(--darkred)":dAway<=7?"var(--mustard)":"var(--muted)"}}>{dAway}d</span>
                          <div style={{display:"flex",alignItems:"center",gap:"0.3rem",fontSize:"0.6rem",color:"var(--muted)"}}>
                            <div className={`fx-prep-dot ${prepCount===5?"fx-prep-done":prepCount>0?"fx-prep-part":"fx-prep-none"}`}/>
                            {prepCount}/5 prep
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              ))
            )
          )}

          {/* ══ RESULTS ══ */}
          {activeTab==="results"&&(
            played.length===0?(
              <div className="fx-empty">
                <div className="fx-empty-icon">📊</div>
                <div className="fx-empty-title">No Results Yet</div>
                <div className="fx-empty-sub">Log results after each match to track your season performance.</div>
              </div>
            ):(
              <>
                <div className="fx-results-header">
                  <div className="fx-results-title">Recent Results — {stats.P} Played</div>
                  <div className="fx-form-strip">
                    {form.map((r,i)=><div key={i} className={`fx-form-badge ${r}`}>{r}</div>)}
                  </div>
                </div>
                {played.map(fx=>{
                  const res = fx.goalsFor>fx.goalsAgainst?"W":fx.goalsFor===fx.goalsAgainst?"D":"L";
                  const fmtDate = formatDate(fx.date);
                  return(
                    <div key={fx.id} className="fx-card played">
                      <div className="fx-date-col">
                        <div className="fx-date-day">{fmtDate.day}</div>
                        <div className="fx-date-month">{fmtDate.month}</div>
                        <div className="fx-date-dow">{fmtDate.dow}</div>
                      </div>
                      <div className="fx-main-col">
                        <span className={`fx-comp-badge ${fx.competition==="League"?"league":fx.competition.includes("Cup")?"cup":"friendly"}`}>{fx.competition}</span>
                        <div className="fx-opp">vs {fx.opponent}</div>
                        <div className="fx-venue"><strong>{fx.venue==="home"?"Home":"Away"}</strong>{fx.possession?` · Poss ${fx.possession}%`:""}{fx.pressEff?` · Press ${fx.pressEff}%`:""}</div>
                        {fx.notes&&<div style={{fontFamily:"'DM Sans',sans-serif",fontSize:"0.65rem",color:"var(--muted)",fontStyle:"italic",marginTop:"0.15rem",fontWeight:300}}>{fx.notes}</div>}
                      </div>
                      <div className="fx-result-col">
                        <div className={`fx-score ${res}`}>{fx.goalsFor}—{fx.goalsAgainst}</div>
                        <span className={`fx-result-badge ${res}`}>{res==="W"?"Win":res==="D"?"Draw":"Loss"}</span>
                      </div>
                    </div>
                  );
                })}
              </>
            )
          )}

          {/* ══ LEAGUE TABLE ══ */}
          {activeTab==="table"&&(
            <div className="fx-table">
              <div className="fx-table-header">
                <div className="fx-table-title">League Table — {new Date().getFullYear()}/{String(new Date().getFullYear()+1).slice(2)}</div>
                <div style={{display:"flex",gap:"0.5rem",alignItems:"center"}}>
                  {leagueTeams.length > 0 && (
                    <span style={{fontFamily:"'DM Sans',sans-serif",fontSize:"0.65rem",color:"var(--muted)",fontStyle:"italic"}}>Your stats auto-calculated · Others entered manually</span>
                  )}
                  <button onClick={()=>setShowEditTable(e=>!e)} style={{padding:"0.28rem 0.7rem",background:showEditTable?"var(--teal)":"transparent",color:showEditTable?"var(--white)":"var(--teal)",border:"1.5px solid var(--teal)",fontFamily:"'DM Sans',sans-serif",fontWeight:800,fontSize:"0.6rem",letterSpacing:"1.5px",textTransform:"uppercase",cursor:"pointer"}}>
                    {showEditTable?"Done":"Edit Table"}
                  </button>
                </div>
              </div>

              {/* Empty state — no teams added yet */}
              {leagueTeams.length === 0 && !showEditTable && (
                <div style={{padding:"3rem 1.5rem",textAlign:"center"}}>
                  <div style={{fontSize:"2.5rem",marginBottom:"0.85rem"}}>🏆</div>
                  <div style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:"1.2rem",letterSpacing:"2px",color:"var(--ink)",marginBottom:"0.4rem"}}>No league set up yet</div>
                  <div style={{fontFamily:"'DM Sans',sans-serif",fontSize:"0.78rem",color:"var(--muted)",fontWeight:300,lineHeight:1.7,maxWidth:380,margin:"0 auto 1.2rem"}}>
                    Add the other teams in your division to build your league table. Your own results are calculated automatically — you just add the other teams and enter their stats.
                  </div>
                  <button onClick={()=>setShowEditTable(true)} style={{padding:"0.65rem 1.5rem",background:"var(--teal)",color:"var(--white)",border:"none",fontFamily:"'DM Sans',sans-serif",fontWeight:800,fontSize:"0.72rem",letterSpacing:"2px",textTransform:"uppercase",cursor:"pointer"}}>
                    Set Up League Table →
                  </button>
                </div>
              )}

              {/* Edit table panel */}
              {showEditTable&&(
                <div style={{background:"var(--cream2)",borderBottom:"1.5px solid var(--rule)",padding:"1rem"}}>
                  <div style={{fontFamily:"'DM Sans',sans-serif",fontSize:"0.68rem",color:"var(--muted)",fontStyle:"italic",marginBottom:"0.75rem",lineHeight:1.6}}>
                    Add every team in your division. Your own results are calculated automatically from your logged fixtures — just enter the other teams' stats manually.
                  </div>
                  <div style={{display:"flex",gap:"0.5rem",marginBottom:"0.75rem",flexWrap:"wrap"}}>
                    <input
                      style={{background:"var(--white)",border:"1.5px solid var(--rule)",borderBottom:"2px solid var(--teal)",padding:"0.42rem 0.75rem",fontFamily:"'DM Sans',sans-serif",fontSize:"0.82rem",outline:"none",flex:1,minWidth:180,maxWidth:280}}
                      placeholder="Team name e.g. North United FC"
                      value={newTeamName}
                      onChange={e=>setNewTeamName(e.target.value)}
                      onKeyDown={e=>{
                        if(e.key==="Enter"&&newTeamName.trim()) {
                          setLeagueTeams(prev=>[...prev,{name:newTeamName.trim(),P:0,W:0,D:0,L:0,GF:0,GA:0}]);
                          setNewTeamName("");
                        }
                      }}
                    />
                    <button onClick={()=>{if(newTeamName.trim()){setLeagueTeams(prev=>[...prev,{name:newTeamName.trim(),P:0,W:0,D:0,L:0,GF:0,GA:0}]);setNewTeamName("");}}} style={{padding:"0.42rem 1rem",background:"var(--teal)",color:"var(--white)",border:"none",fontFamily:"'DM Sans',sans-serif",fontWeight:800,fontSize:"0.68rem",letterSpacing:"1.5px",textTransform:"uppercase",cursor:"pointer"}}>
                      + Add Team
                    </button>
                    {leagueTeams.length > 0 && (
                      <button onClick={()=>{if(window.confirm("Clear all teams from the table?")) setLeagueTeams([]);}} style={{padding:"0.42rem 0.85rem",background:"transparent",color:"var(--darkred)",border:"1.5px solid var(--darkred)",fontFamily:"'DM Sans',sans-serif",fontWeight:800,fontSize:"0.62rem",letterSpacing:"1.5px",textTransform:"uppercase",cursor:"pointer"}}>
                        Clear All
                      </button>
                    )}
                  </div>
                  {leagueTeams.length > 0 && (
                    <div style={{overflowX:"auto"}}>
                      <table style={{width:"100%",borderCollapse:"collapse",fontFamily:"'DM Sans',sans-serif",fontSize:"0.78rem"}}>
                        <thead>
                          <tr style={{background:"var(--ink)",color:"rgba(255,255,255,0.55)"}}>
                            <th style={{padding:"0.38rem 0.6rem",textAlign:"left",fontWeight:800,fontSize:"0.58rem",letterSpacing:"2px",textTransform:"uppercase"}}>Team</th>
                            {["P","W","D","L","GF","GA"].map(h=><th key={h} style={{padding:"0.38rem 0.55rem",width:40,fontWeight:800,fontSize:"0.58rem",letterSpacing:"2px",textTransform:"uppercase"}}>{h}</th>)}
                            <th style={{width:32}}></th>
                          </tr>
                        </thead>
                        <tbody>
                          {leagueTeams.map((team,i)=>(
                            <tr key={i} style={{borderBottom:"1px solid var(--rule2)"}}>
                              <td style={{padding:"0.3rem 0.3rem"}}>
                                <input style={{background:"transparent",border:"none",borderBottom:"1px solid var(--rule)",padding:"0.18rem 0.35rem",fontFamily:"'DM Sans',sans-serif",fontSize:"0.82rem",fontWeight:700,color:"var(--ink)",outline:"none",width:"100%"}}
                                  value={team.name}
                                  onChange={e=>setLeagueTeams(prev=>prev.map((t,j)=>j===i?{...t,name:e.target.value}:t))}/>
                              </td>
                              {["P","W","D","L","GF","GA"].map(field=>(
                                <td key={field} style={{padding:"0.3rem 0.2rem"}}>
                                  <input type="number" min="0"
                                    style={{background:"transparent",border:"none",borderBottom:"1px solid var(--rule)",padding:"0.18rem 0.25rem",fontFamily:"'Bebas Neue',sans-serif",fontSize:"0.95rem",letterSpacing:"1px",color:"var(--ink)",outline:"none",width:40,textAlign:"center"}}
                                    value={team[field]||0}
                                    onChange={e=>setLeagueTeams(prev=>prev.map((t,j)=>j===i?{...t,[field]:Number(e.target.value)||0}:t))}/>
                                </td>
                              ))}
                              <td>
                                <button onClick={()=>setLeagueTeams(prev=>prev.filter((_,j)=>j!==i))} style={{background:"transparent",border:"none",color:"var(--muted)",cursor:"pointer",fontSize:"0.75rem",padding:"0.2rem 0.4rem"}}>✕</button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                  {leagueTeams.length === 0 && (
                    <div style={{fontFamily:"'DM Sans',sans-serif",fontSize:"0.72rem",color:"var(--muted)",fontStyle:"italic",padding:"0.5rem 0"}}>
                      No teams added yet — type a team name above and press Enter or click + Add Team.
                    </div>
                  )}
                </div>
              )}

              {/* Table display */}
              {table.length > 0 && (
                <>
                  <table className="fx-league-table">
                    <thead>
                      <tr>
                        <th style={{width:32}}>#</th>
                        <th>Club</th>
                        <th>P</th><th>W</th><th>D</th><th>L</th>
                        <th>GF</th><th>GA</th><th>GD</th>
                        <th style={{background:"var(--teal2)",color:"white"}}>Pts</th>
                      </tr>
                    </thead>
                    <tbody>
                      {table.map((team,i)=>(
                        <tr key={i} className={team.isMe?"my-team":""}>
                          <td><span className={`fx-pos-num ${i<4?"top":""}`}>{i+1}</span></td>
                          <td>{team.isMe?<strong>{team.name}</strong>:team.name}</td>
                          <td>{team.P}</td>
                          <td style={{color:"#16a34a",fontWeight:700}}>{team.W}</td>
                          <td>{team.D}</td>
                          <td style={{color:"var(--darkred)"}}>{team.L}</td>
                          <td>{team.GF}</td>
                          <td>{team.GA}</td>
                          <td style={{color:team.GD>0?"#16a34a":team.GD<0?"var(--darkred)":"var(--muted)",fontWeight:600}}>{team.GD>0?"+":""}{team.GD}</td>
                          <td><span className="fx-pts">{team.Pts}</span></td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div style={{padding:"0.75rem 1rem",fontFamily:"'DM Sans',sans-serif",fontSize:"0.65rem",color:"var(--muted)",fontStyle:"italic",borderTop:"1px solid var(--rule2)"}}>
                    ✦ Your points are calculated from logged League results. Other teams' stats are entered manually via Edit Table.
                  </div>
                </>
              )}
            </div>
          )}
        </div>

        {/* Add fixture modal */}
        {showAddModal&&(
          <div className="fx-modal-bg" onClick={()=>setShowAddModal(false)}>
            <div className="fx-modal" onClick={e=>e.stopPropagation()}>
              <div className="fx-modal-head">
                <div className="fx-modal-title">Add Fixture</div>
                <button className="fx-modal-close" onClick={()=>setShowAddModal(false)}>✕</button>
              </div>
              <div className="fx-modal-body">
                <label className="fx-form-label">Opponent *</label>
                <input className="fx-form-input" placeholder="e.g. North United" value={newFx.opponent} onChange={e=>setNewFx(p=>({...p,opponent:e.target.value}))}/>
                <div className="fx-form-row">
                  <div>
                    <label className="fx-form-label">Date *</label>
                    <input className="fx-form-input" type="date" value={newFx.date} onChange={e=>setNewFx(p=>({...p,date:e.target.value}))}/>
                  </div>
                  <div>
                    <label className="fx-form-label">Kick-off</label>
                    <input className="fx-form-input" type="time" value={newFx.kickoff} onChange={e=>setNewFx(p=>({...p,kickoff:e.target.value}))}/>
                  </div>
                </div>
                <div className="fx-form-row">
                  <div>
                    <label className="fx-form-label">Venue</label>
                    <select className="fx-form-select" value={newFx.venue} onChange={e=>setNewFx(p=>({...p,venue:e.target.value}))}>
                      <option value="home">Home</option>
                      <option value="away">Away</option>
                    </select>
                  </div>
                  <div>
                    <label className="fx-form-label">Competition</label>
                    <select className="fx-form-select" value={newFx.competition} onChange={e=>setNewFx(p=>({...p,competition:e.target.value}))}>
                      {COMP_NAMES.map(c=><option key={c}>{c}</option>)}
                    </select>
                  </div>
                </div>
                <div className="fx-modal-actions">
                  <button className="fx-btn-s" onClick={()=>setShowAddModal(false)}>Cancel</button>
                  <button className="fx-btn-p" onClick={addFixture} disabled={!newFx.opponent||!newFx.date}>Add Fixture</button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
